import { render } from "./SSTDataset.vue?vue&type=template&id=0fd699e4"
import script from "./SSTDataset.vue?vue&type=script&lang=js"
export * from "./SSTDataset.vue?vue&type=script&lang=js"
script.render = render

export default script